import CreateIcon from '@material-ui/icons/Create';
import { Tooltip } from '@opendoor/mosaic';

const ComingSoonEditButton = () => {
  return (
    <Tooltip
      title="Editing will be available in a future release update"
      aria-label="coming-soon"
      placement="top"
    >
      <span className="items-center gray3">
        <CreateIcon className="pr-1" style={{ width: 14, height: 14 }} />
        Edit
      </span>
    </Tooltip>
  );
};

export default ComingSoonEditButton;
